export default "__VITE_ASSET__g5AZh0Vh__"